import * as yup from "yup";

const latitudeLongitudeRegex = /^-?\d+(\.\d{1,6})?$/;

 export const latitudeValidation = yup
    .string()
    .matches(latitudeLongitudeRegex, "Invalid format (Max 6 decimal places)")
    .test("is-valid-latitude", "Latitude must be between -90 and 90", (value) => {
        if (!value) return false;
        const num = parseFloat(value);
        return num >= -90 && num <= 90;
    })
    .required("Latitude is required");

 export const longitudeValidation = yup
    .string()
    .matches(latitudeLongitudeRegex, "Invalid format (Max 6 decimal places)")
    .test("is-valid-longitude", "Longitude must be between -180 and 180", (value) => {
        if (!value) return false;
        const num = parseFloat(value);
        return num >= -180 && num <= 180;
    })
    .required("Longitude is required");